import React, {useState} from 'react'

function parseCookiesFromCurl(curlCommand: string) {
  let cookieString = ''

  // Try -b 'cookies'
  const bFlagMatch = curlCommand.match(/-b\s+['"]([^'"]+)['"]/)
  if (bFlagMatch) {
    cookieString = bFlagMatch[1]
  }

  // Try -H 'cookie: ...'
  if (!cookieString) {
    const cookieHeaderMatch = curlCommand.match(/-H\s+['"][Cc]ookie:\s*([^'"]+)['"]/)
    if (cookieHeaderMatch) {
      cookieString = cookieHeaderMatch[1]
    }
  }

  if (!cookieString) return null

  return cookieString
    .split(';')
    .map((pair) => {
      const [name, ...valueParts] = pair.trim().split('=')
      return {
        name: name.trim(),
        value: valueParts.join('=').trim(),
        domain: '.facebook.com',
        path: '/',
        httpOnly: false,
        secure: true,
      }
    })
    .filter((c) => c.name && c.value)
}

const CurlToCookiesPage: React.FC = () => {
  const [curlText, setCurlText] = useState('')
  const [result, setResult] = useState('')
  const [copied, setCopied] = useState(false)

  const handleConvert = () => {
    const cookies = parseCookiesFromCurl(curlText)
    if (!cookies || cookies.length === 0) {
      setResult('No cookies found. Make sure the curl has -b or Cookie header.')
      return
    }
    setResult(JSON.stringify(cookies))
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(result)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div style={{padding: '24px', direction: 'rtl', maxWidth: '900px'}}>
      <h2
        style={{fontSize: '22px', fontWeight: 700, color: '#1f2937', marginBottom: '24px'}}
      >
        <i className='bi bi-terminal' style={{marginLeft: '8px'}}></i>
        Curl to Puppeteer Cookies
      </h2>

      {/* Input card */}
      <div
        style={{
          background: '#fff',
          borderRadius: '12px',
          border: '1px solid #e5e7eb',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            padding: '16px 20px',
            background: '#f9fafb',
            borderBottom: '1px solid #e5e7eb',
          }}
        >
          <h3 style={{margin: 0, fontSize: '16px', fontWeight: 600, color: '#1f2937'}}>
            Paste curl command
          </h3>
        </div>

        <div style={{padding: '20px'}}>
          <textarea
            value={curlText}
            onChange={(e) => setCurlText(e.target.value)}
            rows={10}
            dir='ltr'
            style={{
              width: '100%',
              padding: '12px 14px',
              background: '#f9fafb',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              fontSize: '13px',
              color: '#374151',
              fontFamily: 'monospace',
              resize: 'vertical',
              boxSizing: 'border-box',
            }}
            placeholder="curl 'https://www.facebook.com/...' -b 'cookie1=val1; cookie2=val2' ..."
          />

          <button
            onClick={handleConvert}
            style={{
              marginTop: '16px',
              padding: '10px 24px',
              background: '#2b70fa',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              fontWeight: 600,
              fontSize: '14px',
              cursor: 'pointer',
            }}
          >
            Convert
          </button>
        </div>
      </div>

      {/* Result card */}
      {result && (
        <div
          style={{
            marginTop: '24px',
            background: '#fff',
            borderRadius: '12px',
            border: '1px solid #e5e7eb',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              padding: '16px 20px',
              background: '#f9fafb',
              borderBottom: '1px solid #e5e7eb',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h3 style={{margin: 0, fontSize: '16px', fontWeight: 600, color: '#1f2937'}}>
              Minified JSON
            </h3>
            <button
              onClick={handleCopy}
              style={{
                padding: '6px 16px',
                background: copied ? '#10b981' : '#374151',
                color: '#fff',
                border: 'none',
                borderRadius: '6px',
                fontSize: '13px',
                fontWeight: 500,
                cursor: 'pointer',
              }}
            >
              {copied ? 'Copied!' : 'Copy'}
            </button>
          </div>

          <div style={{padding: '20px'}}>
            <pre
              dir='ltr'
              style={{
                background: '#1f2937',
                color: '#e5e7eb',
                padding: '16px',
                borderRadius: '8px',
                overflow: 'auto',
                fontSize: '12px',
                fontFamily: 'monospace',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-all',
                margin: 0,
              }}
            >
              {result}
            </pre>
          </div>
        </div>
      )}
    </div>
  )
}

export default CurlToCookiesPage
